/**
 * Notification preferences + in-app notification feed API endpoints
 */

import { fetchApi, buildQueryString } from '../core';
import type {
  NotificationPreferenceResponse,
  UpdateNotificationPreferenceData,
  NotificationListResponse,
  UnreadCountResponse,
  MarkAllReadResponse,
  ListNotificationsParams,
} from '../types';

export function getMyPreferences(componentName: string = 'Unknown') {
  return fetchApi<NotificationPreferenceResponse>(
    '/me/notification-preferences',
    {},
    componentName
  );
}

export function updateMyPreferences(
  data: UpdateNotificationPreferenceData,
  componentName: string = 'Unknown'
) {
  return fetchApi<NotificationPreferenceResponse>(
    '/me/notification-preferences',
    { method: 'PUT', body: JSON.stringify(data) },
    componentName
  );
}

export function listNotifications(
  params: ListNotificationsParams = {},
  componentName: string = 'Unknown'
) {
  const query = buildQueryString({
    read: params.read === undefined ? undefined : String(params.read),
    category: params.category,
    page: params.page,
    page_size: params.page_size,
  });
  return fetchApi<NotificationListResponse>(
    `/notifications${query}`,
    {},
    componentName
  );
}

export function getUnreadCount(componentName: string = 'Unknown') {
  return fetchApi<UnreadCountResponse>(
    '/notifications/unread-count',
    {},
    componentName
  );
}

export function markNotificationRead(
  id: string,
  componentName: string = 'Unknown'
) {
  return fetchApi<{ status: string }>(
    `/notifications/${id}/read`,
    { method: 'POST' },
    componentName
  );
}

export function markAllNotificationsRead(componentName: string = 'Unknown') {
  return fetchApi<MarkAllReadResponse>(
    '/notifications/read-all',
    { method: 'POST' },
    componentName
  );
}
